import * as React from "react";
import { AuthAndUserConsumer } from "./../AuthProvider";

interface Props {
  children?: React.ReactNode;
  fallback?: React.ReactNode;
  scope?: string;
}

const IfAuthenticated = (props: Props) => {
  const { children, fallback, scope } = props;
  return (
    <AuthAndUserConsumer>
      {({ auth }) =>
        auth.isAuthenticated() && (!scope || auth.hasScope(scope))
          ? children
          : fallback || null
      }
    </AuthAndUserConsumer>
  );
};

export default IfAuthenticated;



// WEBPACK FOOTER //
// ./src/components/IfAuthenticated/IfAuthenticated.tsx